export default "__VITE_ASSET__CgU8Ja0t__"